<template>
  <div class="menu menuPadding">
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <template v-if="showComponents">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.mdAndUp"></v-col>
        <v-col :cols="11">
          <v-row no-gutters class="mb-6">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-account-supervisor</v-icon>
            </v-col>
            <v-col>
              <h2 class="menuHeaders">{{ isIAMAdmin ? 'Manage Office Admin Users' : 'View Office Admin Users' }}</h2>
              <router-link to="/usermanagement" class="menuLinks">
                <v-btn color="green" dark class="menuBtn">Office Admins</v-btn>
              </router-link>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-6">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-account-convert</v-icon>
            </v-col>
            <v-col>
              <h2 class="menuHeaders">{{ isIAMAdmin ? 'Manage True Writing Agents' : 'View True Writing Agents' }}</h2>
              <router-link to="/truewriting" class="menuLinks">
                <v-btn color="green" dark class="menuBtn"
                  >True Writing Agents</v-btn
                >
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <br /><br /><br />
    </template>

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitCircle"
      size="50"
      class="waitCircle"
    ></v-progress-circular>
  </div>
</template>
<script>
import utilityMixins from "@/utility-mixins.js";
import { HTTP_GAP, IAMRoleName } from "@/http-common.js";
export default {
  mixins: [utilityMixins],
  created() {
    this.checkDownlineAgents();
  },
  computed: {
    isIAMAdmin() {
      return this.$store.state.userRoles && this.$store.state.userRoles.indexOf(IAMRoleName) >= 0;
    },
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "200";
    },
    showComponents() {
      return this.showLinks;
    },
    showLinks() {
      return this.users.length > 0;
    }
  },
  data() {
    return {
      waitCircle: false,
      users: []
    };
  },
  methods: {
    async checkDownlineAgents() {
      this.waitCircle = true;
      this.users = [];
      try {
        const results = await HTTP_GAP.get("ReadAgentTrueWriting", {
          params: {
            TMKClientID: window.sessionStorage.getItem("tmkClientId")
          }
        });
        if (results.status == 200) {
          this.$store.commit("setShowTrueWriting", results.data && results.data.length > 0);
          if (results.data.length == 0) {
            return this.$router.push("/usermanagement");
          }
          results.data.map(u => {
            u.Name =
              u.FirstName +
              (u.MiddleName ? " " + u.MiddleName : "") +
              " " +
              u.LastName;
            u.Email = u.FederationID;
            if (
              u.TrueWritingStatus == undefined ||
              u.TrueWritingStatus == "" ||
              u.TrueWritingStatus == null
            ) {
              u.TrueWritingStatus = u.AccessStatusDescription;
            }
            if (
              u.TrueWritingFederationID == undefined ||
              u.TrueWritingFederationID == "" ||
              u.TrueWritingFederationID == null
            ) {
              u.TrueWritingFederationID = u.FederationID;
            }
            u.Status =
              u.TrueWritingStatus == u.AccessStatusDescription &&
              u.TrueWritingFederationID == u.FederationID
                ? u.AccessStatusDescription
                : "Pending";
          });
          this.users = this.users.concat(results.data);
        } else {
          this.$modal.show("errorModal");
        }
        this.waitCircle = false;
        if (!this.showLinks) {
          return this.$router.push("/usermanagement");
        }
      } catch (e) {
        this.waitCircle = false;
        this.$modal.show("errorModal");

        this.addToErrorLogs("GapManagement.vue get ReadAgentTrueWriting", e);
      }
    }
  }
};
</script>
<style scoped>
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 45%;
  left: 47%;
  margin-top: 200px;
}
.menuHeaders {
  color: #00558c;
}
.menu {
  margin-left: 50px;
}
.menuPadding {
  margin-top: 100px;
}
.menuBtn {
  margin-top: 10px;
  text-transform: none !important;
  letter-spacing: normal;
  border-radius: 20px;
}
.disabledPointer {
  cursor: default;
}
.menuLinks {
  text-decoration: none !important;
  color: inherit;
}
.wrap {
  word-wrap: break-word !important;
}
</style>
